import React from "react";
import Select from "react-select";

import { StoreContext } from "app/context/Store";

import "./select-dropdown.css";

function SelectDropdown(props) {
  const context = React.useContext(StoreContext);
  const primaryColor = context?.state?.clientConfigData?.clientConfigs
    .filter((data) => data.name === "--theme-deafult")
    .map((items) => {
      return items.value;
    });
    
  const secondaryColor = context?.state?.clientConfigData?.clientConfigs
    .filter((data) => data.name === "--secondary-color")
    .map((items) => {
      return items.value;
    });

  const {
    dropdownOptions,
    defaultSelected,
    isDisabled,
    onChange,
    placeholderText,
  } = props;

  const styleConfigs = {
    control: (base, { isSelected }) => ({
      ...base,
      border: isSelected
        ? `2px solid ${primaryColor}`
        : `2px solid ${primaryColor}`,
      "&:hover": {
        border: `2px solid ${primaryColor}`,
      },
      boxShadow: "none",
    }),
    option: (styles, { isDisabled, isFocused, isSelected }) => {
      return {
        ...styles,
        backgroundColor: isDisabled
          ? undefined
          : isSelected
          ? primaryColor
          : isFocused
          ? secondaryColor
          : undefined,
        color: isSelected ? "#40b895" : "Black",
      };
    },
  };

  return (
    <>
      <div className="form-group select-custom">
        {/* <select className="form-control " id="reminderoptions">
          <option>{title}</option>
        </select> */}
        <Select
          options={dropdownOptions}
          value={defaultSelected}
          isDisabled={isDisabled}
          onChange={onChange}
          placeholder={placeholderText}
          styles={styleConfigs}
        />
      </div>
    </>
  );
}

export default SelectDropdown;
